import { http, HttpResponse, PathParams } from "msw";

import { DeploymentScansResponse, Scan, ScanResponse } from "@shared/types";

import { SCAN_LOG_OUTPUT } from "./scanLogOutput";

const now = new Date();
export const TEST_SCANS: Scan[] = [
  {
    id: 0,
    deployment_id: 1,
    repository_id: 0,
    completed_at: "2021-01-01T00:00:00Z",
    started_at: "2021-01-01T00:00:00Z",
    exit_code: 0,
  },
  {
    id: 1,
    deployment_id: 1,
    repository_id: 0,
    completed_at: "2021-01-02T01:01:01Z",
    started_at: "2021-01-02T01:01:01Z",
    exit_code: 0,
  },
  {
    id: 2,
    deployment_id: 1,
    repository_id: 3,
    completed_at: "2021-01-01T00:00:00Z",
    started_at: "2021-01-01T00:00:00Z",
    exit_code: 0,
  },
  {
    id: 3,
    deployment_id: 1,
    repository_id: 3,
    completed_at: now.toISOString(),
    started_at: now.toISOString(),
    exit_code: 0,
  },
  {
    id: 4,
    deployment_id: 1,
    repository_id: 4,
    completed_at: "2021-01-01T00:00:00Z",
    started_at: "2021-01-01T00:00:00Z",
    exit_code: 0,
  },
];

export const scanHandlersStatic = [
  http.get<PathParams, ScanResponse>("*/api/agent/scans/:id", () =>
    HttpResponse.json({ scan: TEST_SCANS[0] }, { status: 200 })
  ),

  http.get<PathParams, DeploymentScansResponse>(
    "*/api/agent/deployments/:id/scans",
    () => HttpResponse.json({ scans: TEST_SCANS }, { status: 200 })
  ),

  http.get<PathParams, DeploymentScansResponse>(
    "*/api/agent/scans/:id/logs",
    () => HttpResponse.json({ log: SCAN_LOG_OUTPUT }, { status: 200 })
  ),

  http.post<PathParams, DeploymentScansResponse>(
    "*/api/agent/deployments/:id/scans/run",
    () =>
      HttpResponse.json(
        { tasks: [{ repo_id: 1, task_id: 1 }], errors: [] },
        { status: 200 }
      )
  ),
];
